import React from "react";
import { motion } from "framer-motion";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#032033] flex items-center justify-center p-6 relative overflow-hidden">
      {/* Background Blur Elements */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#c6e7f9]/20 rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#c6e7f9]/10 rounded-full blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="text-center max-w-3xl"
      >
        {/* Logo */}
        <motion.img
          src="/logo.png" 
          alt="Logo"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2 }}
          className="mx-auto w-40 mb-8 drop-shadow-lg"
        />

        <h1 className="text-6xl md:text-7xl font-bold text-white leading-tight mb-6">
          U Live Stories Studio
        </h1>

        <p className="text-lg md:text-xl text-[#c6e7f9] max-w-xl mx-auto mb-10">
          U Live Stories Studio adalah komunitas kreatif tempat cerita menjadi hidup—melalui game, roleplay, dan pengalaman interaktif.
        </p>

        <div className="mt-10">
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse" }}
            className="px-8 py-4 text-[#c6e7f9] border border-[#c6e7f9] rounded-2xl text-xl tracking-widest backdrop-blur-xl"
          >
            COMING SOON
          </motion.span>
        </div>
      </motion.div>
    </div>
  );
}
